// ItemList.js
import React from 'react';
import './ItemList.css';  // Keep the same CSS file

export function ItemList({ 
  items, 
  onItemClick, 
  titleField = 'title',        // Default field names, can be overridden
  descriptionField = 'description',
  idField = 'id',
  parseResponse = true,        // Whether to parse JSON response
  emptyMessage = 'No items found',
  renderItem
}) {
  const parseItems = (itemsData) => {
    if (!parseResponse) return itemsData;
    
    if (typeof itemsData === 'string') {
      try {
        return JSON.parse(itemsData);
      } catch (e) {
        console.error('Error parsing items:', e);
        return [];
      }
    }
    return itemsData;
  };

  const itemsList = parseItems(items);

  return (
    <div className="item-list-container">
      <div className="item-list">
        {Array.isArray(itemsList) && itemsList.length > 0 ? (
          itemsList.map((item, index) => (
            <div
              key={item.SK}
              className="item-entry"
              onClick={() => onItemClick(item)}
            >
              {renderItem ? renderItem(item, index, itemsList.length) : (
                <>
                  <div className="item-title">{item[titleField]}</div>
                  {item[descriptionField] && (
                    <div className="item-description">{item[descriptionField]}</div>
                  )}
                </>
              )}
            </div>
          ))
        ) : (
          <div className="item-list-empty">{emptyMessage}</div>
        )}
      </div>
    </div>
  );
}